import Box, { BoxProps } from '@mui/material/Box';
import animationData from 'assets/lotties/loadingLottie.json';
import { Loading } from 'components/Loading';
import LottiePlayer from 'components/LottiePlayer';
import './index.css';
import React from 'react';

export interface LoadingAnimationProps extends BoxProps {
    hideBarIndicator?: boolean;
}

const LoadingAnimation: React.FC<LoadingAnimationProps> = React.memo(
    (props) => {
        return (
            <React.Fragment>
                <Box
                    {...props}
                    style={{
                        height: '100%',
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    className="loading-animation-container"
                >
                    <LottiePlayer loop={true} animationData={animationData} />
                </Box>
                <Loading activity={!props.hideBarIndicator} />
            </React.Fragment>
        );
    },
);

export default React.memo(LoadingAnimation);
